// Version : 0.0.1
// Author : SATHISH
// LastEdit : SATHISH
// MODFIED DATE:19-09-2025
//Last ADD :CODE REVIEW CHANGES AND ADD VERSION
const productTypeActionTypes = {
	/*************** START ADD PRODUCT TYPE DETAILS ******************/
	ADD_PRODUCT_TYPE_DETAILS_START: 'add_product_type_details_start',
	ADD_PRODUCT_TYPE_DETAILS_SUCCESS: 'add_product_type_details_success',
	ADD_PRODUCT_TYPE_DETAILS_FAILURE: 'add_product_type_details_failure',
	ADD_PRODUCT_TYPE_DETAILS_RESPONSE_RESET: 'add_product_type_details_response_reset',
	ADD_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED: 'add_product_type_details_response_changed',
	/*************** END ADD PRODUCT TYPE DETAILS ******************/

	/*************** START UPDATE PRODUCT TYPE DETAILS ******************/
	UPDATE_PRODUCT_TYPE_DETAILS_START: 'update_product_type_details_start',
	UPDATE_PRODUCT_TYPE_DETAILS_SUCCESS: 'update_product_type_details_success',
	UPDATE_PRODUCT_TYPE_DETAILS_FAILURE: 'update_product_type_details_failure',
	UPDATE_PRODUCT_TYPE_DETAILS_RESPONSE_RESET: 'update_product_type_details_response_reset',
	UPDATE_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED: 'update_product_type_details_response_changed',
	/*************** END UPDATE PRODUCT TYPE DETAILS ******************/

	/*************** START GET PRODUCT TYPE LIST ******************/
	GET_PRODUCT_TYPE_LIST_START: 'get_product_type_list_start',
	GET_PRODUCT_TYPE_LIST_SUCCESS: 'get_product_type_list_success',
	GET_PRODUCT_TYPE_LIST_FAILURE: 'get_product_type_list_failure',
	GET_PRODUCT_TYPE_LIST_RESPONSE_RESET: 'get_product_type_list_response_reset',
	GET_PRODUCT_TYPE_LIST_RESPONSE_CHANGED: 'get_product_type_list_response_changed',
	/*************** END GET PRODUCT TYPE LIST ******************/

	/*************** START FETCH PRODUCT TYPE DETAILS ******************/
	FETCH_PRODUCT_TYPE_DETAILS_START: 'fetch_product_type_details_start',
	FETCH_PRODUCT_TYPE_DETAILS_SUCCESS: 'fetch_product_type_details_success',
	FETCH_PRODUCT_TYPE_DETAILS_FAILURE: 'fetch_product_type_details_failure',
	FETCH_PRODUCT_TYPE_DETAILS_RESPONSE_RESET: 'fetch_product_type_details_response_reset',
	FETCH_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED: 'fetch_product_type_details_response_changed',
	/*************** END FETCH PRODUCT TYPE DETAILS ******************/

	/*************** START DELETE PRODUCT TYPE DETAILS ******************/
	DELETE_PRODUCT_TYPE_DETAILS_START: 'delete_product_type_details_start',
	DELETE_PRODUCT_TYPE_DETAILS_SUCCESS: 'delete_product_type_details_success',
	DELETE_PRODUCT_TYPE_DETAILS_FAILURE: 'delete_product_type_details_failure',
	DELETE_PRODUCT_TYPE_DETAILS_RESPONSE_RESET: 'delete_product_type_details_response_reset',
	DELETE_PRODUCT_TYPE_DETAILS_RESPONSE_CHANGED: 'delete_product_type_details_response_changed',
	/*************** END DELETE PRODUCT TYPE DETAILS ******************/
};

export default productTypeActionTypes;
